<template>
  <div class="wrapper">
    <Header class="header" data-title="FAQ"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content" class="faq">
        <section class="mt20 mb20">
          <div class="searchWrap faq">
            <input type="text" id="ipt1_1" class="ipt" placeholder="검색어를 입력해주세요" title="검색어 입력" value="" v-model="searchInput" />
            <button type="button" class="btnIco_srch" @click="searchFaqForKeyword"><span>검색</span></button>
          </div>
        </section>

        <div class="tabWrap">
          <ul class="tabList iptBtn div_3 uiAct" id="mainTypeList">
            <li
              v-for="(mainTypeValue, mainTypeIndex) in mainTypeList"
              :class="{ on: mainTypeValue.flag }"
              :key="mainTypeIndex"
              v-text="mainTypeValue.mainTypeName"
              @click="selectMainType(mainTypeValue, mainTypeIndex)"
            ></li>
          </ul>

          <div class="tabContents">
            <div class="tabPanel on">
              <section class="mt20 mb20" v-if="subTypeList.length > 0">
                <div class="linkTab" id="subTypeList">
                  <a :class="{ on: subTypeAllFlag }" @click="selectSubType(null)">전체</a>
                  <a
                    v-for="(subTypeValue, subTypeIndex) in subTypeList"
                    :class="{ on: subTypeValue.flag }"
                    :key="subTypeIndex"
                    v-text="subTypeValue.subTypeName"
                    @click="selectSubType(subTypeValue, subTypeIndex)"
                  ></a>
                </div>
              </section>

              <section class="hr">
                <div class="sortArea" v-if="mainType != null">
                  <div class="lcont">
                    <span class="txtM">
                      <em v-text="mainTypeName"></em>
                      <em v-text="subTypeName"></em>
                      (
                      <span v-text="faqListLength"></span>
                      )
                    </span>
                  </div>
                </div>

                <div class="sortArea" v-if="mainType == null && searchInput != null">
                  <div class="lcont">
                    <span class="txtM">
                      <em>
                        ‘
                        <span v-text="searchInput"></span>
                        ’
                      </em>
                      검색 결과 (
                      <span v-text="faqListLength"></span>
                      )
                    </span>
                  </div>
                </div>

                <ul class="faqList">
                  <li v-for="(faq, faqIndex) in faqList" :key="faqIndex">
                    <div class="accoHead accoBtn">
                      <div class="tit" v-html="faq.qustion.replace(/\r\n/g, '')"></div>
                      <span class="btnIco_acco"><span class="blind">상세보기</span></span>
                    </div>
                    <div class="accoBody">
                      <div class="inner" v-html="faq.answer.replace(/\\r\\n/g, '')"></div>
                    </div>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
      <!-- content(e) -->
      <QuickMenu></QuickMenu>
      <infinite-loading spinner="circles" @infinite="infiniteHandler" v-show="p_flag == 'Y'" />
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import * as customjs from '@/../static/js/m.front.js';
import ApiService from '@/common/api.service';
import QuickMenu from '@/views/app/comm/QuickMenu';
import { isEmpty } from '@/common/common.function.js';
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: 'customerCenterFaq',
  components: {
    QuickMenu,
    InfiniteLoading,
  },
  //props: ['propsKeyword'],
  data: function() {
    return {
      mainTypeList: [],
      subTypeList: [],
      mainType: null,
      mainTypeName: '전체',
      subType: null,
      subTypeName: '전체',
      subTypeAllFlag: true,

      searchInput: null,

      faqList: [],
      faqListLength: 0,

      //페이징 관련
      loadingState: null,
      maxPage: null,
      p_flag: 'Y',
      initFlag: 'N',
      page: 1,
    };
  },
  updated() {
    customjs.accoInit();
  },
  mounted() {
    // customjs.init();

    // faq 대분류 리스트 조회
    ApiService.service('GET', '/board/faq/typeList')
      .then(({ data }) => {
        if (data.isSucceed) {
          this.mainTypeList = data.result;

          if (!this.searchInput) {
            if (this.$route.params.mainType) {
              this.selectMainType(this.mainTypeList[0], 0);
              for (let i = 0; i < this.mainTypeList.length; i++) {
                if (this.mainTypeList[i].mainType == this.$route.params.mainType) {
                  this.selectMainType(this.mainTypeList[i], i);
                }
              }
            } else {
              this.selectMainType(this.mainTypeList[0], 0);
            }
          }
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });

    if (!isEmpty(this.$route.params.propsKeyword)) {
      this.searchInput = this.$route.params.propsKeyword;
    }

    if (this.searchInput) {
      this.searchFaqForKeyword();
    }
  },
  methods: {
    selectMainType: function(mainTypeValue, index) {
      console.log(mainTypeValue);
      this.searchInput = null;
      this.mainType = mainTypeValue.mainType;
      this.mainTypeName = mainTypeValue.mainTypeName;
      this.subType = null;
      this.subTypeName = '전체';

      for (let mainType of this.mainTypeList) {
        mainType.flag = false;
      }

      this.mainTypeList[index].flag = true;
      this.selectSubTypeList();
    },
    selectSubTypeList: function() {
      let paramSubtype = this.$route.params.subType;
      ApiService.service('GET', '/board/faq/typeList/' + this.mainType)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.subTypeList = data.result;
            this.subType = null;
            this.subTypeAllFlag = true;
            if (!isEmpty(paramSubtype)) {
              for (let i = 0; i < this.subTypeList.length; i++) {
                if (this.subTypeList[i].subType == paramSubtype) {
                  this.selectSubType(paramSubtype, i);
                  this.subType = paramSubtype;
                }
              }
            }
            this.selectFaqList();
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    selectFaqList: function() {
      ApiService.service('GET', '/board/faq?mainType=' + this.mainType + '&&subType=' + this.subType + '&&searchInput=' + this.searchInput)
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            this.faqList = [];
            this.initFlag = 'Y';

            this.faqList = data.result.content;
            // this.faqListLength = data.result.content.length;
            this.faqListLength = data.result.totalElements;

            this.count = data.result.totalElements;
            this.maxPage = data.result.totalPages;

            this.p_flag = 'Y';
            this.loadingState.reset();
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    selectSubType: function(subTypeValue, index) {
      this.searchInput = null;
      this.subTypeAllFlag = false;

      if (subTypeValue != null) {
        this.subType = subTypeValue.subType;
        this.subTypeName = subTypeValue.subTypeName;
      } else {
        this.subType = null;
        this.subTypeName = '전체';
      }

      for (let subType of this.subTypeList) {
        subType.flag = false;
      }

      if (subTypeValue == null) {
        this.subTypeAllFlag = true;
      } else {
        this.subTypeList[index].flag = true;
      }
      this.selectFaqList();
    },
    searchFaqForKeyword: function() {
      this.mainType = null;
      this.mainTypeName = '전체';
      this.subType = null;
      this.subTypeName = '전체';

      let children = document.getElementById('mainTypeList').childNodes;
      for (let i = 0; i < children.length; i++) {
        children[i].classList.remove('on');
      }

      this.subTypeList = [];

      this.selectFaqList();
    },
    //스크롤
    infiniteHandler($state) {
      this.loadingState = $state;
      console.log('max : ' + this.maxPage); // page No
      console.log('page : ' + this.page); // page No
      if (this.maxPage < this.page && this.maxPage != null) {
        this.p_flag = 'N';
        return false;
      }

      ApiService.service(
        'GET',
        '/board/faq?mainType=' + this.mainType + '&&subType=' + this.subType + '&&searchInput=' + this.searchInput + '&&page=' + this.page,
      )
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            this.initFlag = 'Y';

            for (let value of data.result.content) {
              this.faqList.push(value);
            }

            this.count = data.result.totalElements;
            this.maxPage = data.result.totalPages;

            if (this.faqList.length != 0) {
              this.page += 1;
              $state.loaded();
            }
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
  },
};
</script>
